import AjaxClass from './Validation/ajaxClass';
import FormValidate from './Validation/formValidateClass';
import MessageHandler from './Validation/messageHandler';
import mask from './../Utils/inputMask';

export default function ContactForm() {
    $("#telefone").mask("(00) 00000-0000");
    $("#contact-form").on('submit', function (e) {
        e.preventDefault();
        const Loader = document.getElementById("loading-forms")
        let form = $(this);
        let fields = form.serializeArray();
        let validation = new FormValidate(fields);
        let terms = $("#termeos").prop('checked') == true;
        validation.validateAll(fields);
        let error = validation.hasError();
        MessageHandler.removeAllFormFailMessages()

        if (error) {
            let errorMessageId = validation.getErrorId();
            console.log(errorMessageId)
            if (errorMessageId != 'termeos') {
                MessageHandler.showFailMessage(errorMessageId, true);
            } 
        }
        if (!error && !terms) {
            const modalSuccess = document.getElementById('success-message-forms');
            const modalSuccessDescription = document.querySelector('#success-message-forms .description');
            modalSuccess.classList.add("open-modal");
            modalSuccessDescription.innerHTML = 'Você deve estar de acordo com a nossa Política de Privacidade!';
            return false;
        }
        
        if (error == false) {
            Loader.classList.add("open-modal");
            if ($(this).attr('disabled') == 'disabled') {
                return false;
            }
            $(this).attr('disabled', 'disabled');
            let type = 'POST';
            let url = $(this).attr('action');
            let dataType = 'json';
            const modalSuccess = document.getElementById('success-message-forms');
            const modalSuccessDescription = document.querySelector('#success-message-forms .description');
            const modalError = document.getElementById('error-message-forms');
            const modalDescription = document.querySelector('#error-message-forms .description');
            class Contact extends AjaxClass {
                successFunction(data, form) {
                    Loader.classList.remove("open-modal");
                    if (data.status == true) {
                        $('#contact-form').trigger("reset");
                        $("#contact-form").removeAttr('disabled');
                        modalSuccess.classList.add("open-modal");
                        modalSuccessDescription.innerHTML = 'Cadastro realizado com sucesso. Fique atento ao email!'
                    } else {
                        modalDescription.innerHTML = data.txt;
                        modalError.classList.add("open-modal");
                        $("#contact-form").removeAttr('disabled');
                    }
                };
                errorFunction(xhr, textStatus, errorThrown) {
                    Loader.classList.remove("open-modal");
                    modalDescription.innerHTML = "Ocorreu um erro. Tente novamente mais tarde.";
                    modalError.classList.add("open-modal");
                    $("#contact-form").removeAttr('disabled');
                };
            }
            let ajax = new Contact(form, type, url, dataType, form.serialize());
            ajax.send();
        }

        return false;
    });
}